import { useState } from 'react';
import { useAdminStatus } from '@/hooks/useAdminStatus';
import { useImpersonation, type ImpersonatedRole } from '@/contexts/ImpersonationContext';
import styles from './ImpersonationControls.module.scss';
import { motion, AnimatePresence } from 'motion/react';

// Icons
import AngryIcon from '@/assets/common/angry.svg?react';

export function ImpersonationControls() {
    const { isAdmin } = useAdminStatus();
    const { impersonatedRole, setImpersonatedRole } = useImpersonation();
    const [isOpen, setIsOpen] = useState(false);

    if (!isAdmin) return null;

    const roles: { value: ImpersonatedRole; label: string }[] = [
        { value: null, label: 'Viewing as: Admin (Default)' },
        { value: 'logged-out', label: 'Simulate: Logged Out' },
        { value: 'foundation', label: 'Simulate: Foundation Tier' },
        { value: 'deep_dive', label: 'Simulate: Deep Dive Tier' },
        { value: 'mastermind', label: 'Simulate: Mastermind Tier' },
    ];

    return (
        <div className={styles.impersonationWrapper}>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className={styles.impersonationPanel}
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                    >
                        <div className={styles.impersonationHeader}>
                            <span className={styles.impersonationTitle}>Impersonate Role</span>
                            <button
                                className={styles.closeButton}
                                onClick={() => setIsOpen(false)}
                            >
                                ×
                            </button>
                        </div>
                        <div className={styles.roleList}>
                            {roles.map((role) => (
                                <button
                                    key={String(role.value)}
                                    className={`${styles.roleButton} ${impersonatedRole === role.value ? styles.active : ''}`}
                                    onClick={() => {
                                        setImpersonatedRole(role.value);
                                        if (role.value === null) setIsOpen(false);
                                    }}
                                >
                                    {role.label}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.button
                className={`${styles.toggleButton} ${impersonatedRole ? styles.active : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
            >
                <AngryIcon />
                {impersonatedRole ? ' Impersonating' : ' Admin Tools'}
            </motion.button>
        </div>
    );
}
